import React from 'react'
import { StaticDatePicker as DatePicker } from '@mui/x-date-pickers'
import T from 'prop-types'

export default function StaticDatePicker({ value, onChange, ...others }) {
  return (
    <DatePicker
      displayStaticWrapperAs="desktop"
      value={value}
      onChange={onChange}
      {...others}
    />
  )
}

StaticDatePicker.propTypes = {
  value: T.instanceOf(Date),
  onChange: T.func,
}
